import React from 'react';

import useMrcStore from 'common/stores/mrcStore';
import {shallow} from 'zustand/shallow';

export function useMrcList(search?: string) {
	const {list, queryResault} = useMrcStore((state) => ({
		list: state.list,
		queryResault: state.queryResault,
	}), shallow);

	// Return queryResault if searching (even if empty), otherwise list
	return React.useMemo(() => {
		if (queryResault && search && search.trim() !== '') {
			// Return queryResault when searching, even if it's null or empty
			return queryResault;
		}
		return list;
	}, [search, list, queryResault]);
}
